import React from 'react';
import Explain from './Explain';

/**
 * "Don't see your firm?": a quiet link that lists the prop firms the risk
 * tools don't offer yet and why (waiting for their rules to be confirmed,
 * listed under another name, or not tracked). From /api/prop-firm-presets.
 */
export default function MissingFirms({ firms, className = '' }) {
  if (!firms?.length) return null;
  return (
    <span className={`pfm ${className}`.trim()}>
      <Explain
        title="Firms not listed yet"
        body={(
          <>
            <p className="pfx-note">A firm is listed once RiskLo has its rules. They’re checked against each firm’s own website every week.</p>
            <ul className="pfm-list">
              {firms.map((f) => (
                <li key={f.firm}>
                  <b>{f.site ? <a href={f.site} target="_blank" rel="noopener noreferrer nofollow">{f.firm} ↗</a> : f.firm}</b>
                  <span>{f.reason}</span>
                </li>
              ))}
            </ul>
          </>
        )}
      >
        Don’t see your firm?
      </Explain>
    </span>
  );
}
